// extracted by mini-css-extract-plugin
module.exports = {"treeRoot":"ReactSortableTree_treeRoot__1aCEl"};